import type { PostProcessorModule } from 'i18next';

/**
 * Keys this session actually asked for. `requested` proves a key is in use on the pages
 * visited; `missing` is the set i18next could not resolve at all, which is the signal
 * behind most "translation is missing" reports.
 */
export const keyAccessLog = {
  requested: new Set<string>(),
  missing: new Set<string>(),
};

export const recordMissingKey = (key: string) => keyAccessLog.missing.add(key);

export const keyAccessPostProcessor: PostProcessorModule = {
  type: 'postProcessor',
  name: 'recordKeyAccess',
  process(value: string, key: string | string[]) {
    if (Array.isArray(key)) {
      key.forEach(item => keyAccessLog.requested.add(item));
    } else {
      keyAccessLog.requested.add(key);
    }
    return value;
  },
};
